import { createSelector, select } from '@ngrx/store';

import { BookingFeatureState, PaxDetailsState } from '../../interfaces';
import { bookingFeatureState } from './booking-feature-state.selector';

// eslint-disable-next-line no-underscore-dangle
const _paxDetailsPassengers = createSelector(bookingFeatureState, (bfs: BookingFeatureState) => bfs?.paxDetails);
const _filteredPaxDetailsPassengers = (passengerIds: string[]) =>
  createSelector(_paxDetailsPassengers, (pxd: PaxDetailsState) => ({
    ...pxd,
    passengers: pxd?.passengers?.filter((p) => passengerIds.includes(p.travelerId)),
  }));

export const paxDetailTravelerSelector = createSelector(
  _paxDetailsPassengers,
  (pxd: PaxDetailsState) => pxd?.passengers
);

export const paxDetails = () => select(_paxDetailsPassengers);
export const filteredPaxDetails = (passengerIds: string[]) => select(_filteredPaxDetailsPassengers(passengerIds));
